/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdpClaimMappingDto
 */
export interface IdpClaimMappingDto {
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof IdpClaimMappingDto
     */
    priority?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IdpClaimMappingDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingDto
     */
    targetType?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingDto
     */
    claimType?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingDto
     */
    claimValue?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingDto
     */
    roleId?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingDto
     */
    roleName?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingDto
     */
    groupName?: string;
}

/**
 * Check if a given object implements the IdpClaimMappingDto interface.
 */
export function instanceOfIdpClaimMappingDto(value: object): value is IdpClaimMappingDto {
    return true;
}

export function IdpClaimMappingDtoFromJSON(json: any): IdpClaimMappingDto {
    return IdpClaimMappingDtoFromJSONTyped(json, false);
}

export function IdpClaimMappingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdpClaimMappingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'targetType': json['target_type'] == null ? undefined : json['target_type'],
        'claimType': json['claim_type'] == null ? undefined : json['claim_type'],
        'claimValue': json['claim_value'] == null ? undefined : json['claim_value'],
        'roleId': json['role_id'] == null ? undefined : json['role_id'],
        'roleName': json['role_name'] == null ? undefined : json['role_name'],
        'groupId': json['group_id'] == null ? undefined : json['group_id'],
        'groupName': json['group_name'] == null ? undefined : json['group_name'],
    };
}

export function IdpClaimMappingDtoToJSON(json: any): IdpClaimMappingDto {
    return IdpClaimMappingDtoToJSONTyped(json, false);
}

export function IdpClaimMappingDtoToJSONTyped(value?: IdpClaimMappingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'priority': value['priority'],
        'enabled': value['enabled'],
        'target_type': value['targetType'],
        'claim_type': value['claimType'],
        'claim_value': value['claimValue'],
        'role_id': value['roleId'],
        'role_name': value['roleName'],
        'group_id': value['groupId'],
        'group_name': value['groupName'],
    };
}

